(function ($, Drupal) {
  /* To understand behaviors, see https://drupal.org/node/756722#behaviors */

  Drupal.behaviors.initMediaVideo = {
    attach: function (context, settings) {
      $(document).ready(function () {

        /* click on play button to play video */
        $('.video-container .video_button .video_button-play').on('click', function () {

          /* play video */
          $(this).parent().prev().trigger('play');

          /* hide play button */
          $(this).hide();
        });

        /* click on video to pause video */
        $("video").on('click', function () {
          /* pause video */
          $(this).trigger('pause');

          /* show play button */
          $(this).next().children().show();;
        });
      });
    }
  };

}(jQuery, Drupal));
